import React from "react";
import "../Counter.css";


const MainCounter = ({ daysTogether, counterStyleLabel, counterStyleValue }) => {
  
  return (
    <div className="main-counter">
      <div className="counter-value" style={counterStyleValue}>{daysTogether}</div>
      <div className="counter-label" style={counterStyleLabel}>days together</div>
    </div>
  );
};

export default MainCounter;
